import { defineStore } from "pinia";
import type { ReleaseNote } from '../domain/releaseNote';
import { computed, ref } from "vue";

export const useReleaseNoteStore = defineStore('release-notes', () => {
  const list = ref<ReleaseNote[]>([]);
  const initialized = ref<boolean>(false);

  function merge(notes: ReleaseNote[]) {
    list.value = notes;
    initialized.value = true;
  }

  return {
    list,
    merge,
    latest: computed(() => {
      const notes = list.value;
      if (notes.length === 0) return undefined;
      return notes[0];
    })
  };
});
